import { interestServicingPercentageResolver } from "resolvers";
import {
  INTEREST_SERVICE_LEVEL_FULL,
  INTEREST_SERVICE_LEVEL_SPECIFIED,
  INTEREST_SERVICE_VALID_PERCENTAGES,
} from "lib/constants";

const interestServicingLevelResolver = (value) => {
  const percentage = interestServicingPercentageResolver(value);

  if (percentage === INTEREST_SERVICE_VALID_PERCENTAGES[100]) {
    return INTEREST_SERVICE_LEVEL_FULL;
  } else {
    return INTEREST_SERVICE_LEVEL_SPECIFIED;
  }
};

export default interestServicingLevelResolver;
